import { render, staticRenderFns } from "./menu-tree.vue?vue&type=template&id=6b7223d2&scoped=true"
import script from "./menu-tree.vue?vue&type=script&lang=js"
export * from "./menu-tree.vue?vue&type=script&lang=js"
import style0 from "./menu-tree.vue?vue&type=style&index=0&id=6b7223d2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7223d2",
  null
  
)

export default component.exports